import { render, staticRenderFns } from "./ProfitPdf.vue?vue&type=template&id=f9770f8a&scoped=true"
import script from "./ProfitPdf.vue?vue&type=script&lang=js"
export * from "./ProfitPdf.vue?vue&type=script&lang=js"
import style0 from "./ProfitPdf.vue?vue&type=style&index=0&id=f9770f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9770f8a",
  null
  
)

export default component.exports